import { GET_TUTORIAL_VIDEOS_SUCCESS } from './tutorialVideos.types';

const initialState = {
    /**
     * Platform and org videos merged by the api, each carrying `source` and
     * freshly signed `file.url` / `thumbnail.url`. The URLs expire, so this
     * list is a snapshot of one page load, not something to persist.
     */
    tutorialVideos: [],
};

export const tutorialVideosReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_TUTORIAL_VIDEOS_SUCCESS:
            return {
                ...state,
                tutorialVideos: action.payload,
            };

        default:
            return state;
    }
};
